import { NcarbSettings } from '../../services/api/NcarbSettings';

export class NcarbTransmittalDownloadInfo {
  public link: string;
  constructor(jsonFromNcarb: any, ncarb: NcarbSettings) {
    this.link = `${ncarb.url}Home/Members/TransmittalUploads/View/${jsonFromNcarb.id}?file=${jsonFromNcarb.fileName}`;
  }
}
